import { cn } from '@/utils/classnames';

export interface SkeletonRowProps {
  /** Number of rows to render. Defaults to 1. */
  count?: number;
  /** Number of "cell" placeholders per row. Defaults to 4. */
  cells?: number;
  className?: string;
}

/**
 * Lightweight shimmer rows used for table-style loading states.
 * Each cell uses a CSS animated gradient — no JS animation loop.
 */
export function SkeletonRow({ count = 1, cells = 4, className }: SkeletonRowProps) {
  return (
    <div className={cn('flex flex-col gap-stack-sm', className)}>
      {Array.from({ length: count }).map((_, rowIdx) => (
        <div key={rowIdx} className="flex items-center gap-stack-sm">
          {Array.from({ length: cells }).map((__, cellIdx) => (
            <div
              key={cellIdx}
              className={cn(
                'h-4 flex-1 animate-pulse rounded bg-surface-container-high',
                cellIdx === cells - 1 ? 'max-w-[120px]' : '',
              )}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
